export const FundsErrorIcon = () => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5641 18.4506L11.9303 13.8169L7.29654 18.4506C6.94495 18.8022 6.37485 18.8022 6.02326 18.4506L5.17613 17.6034C4.82455 17.2519 4.82455 16.6817 5.17613 16.3301L9.80987 11.6964L5.17613 7.06271C4.82455 6.71112 4.82455 6.14101 5.17613 5.78941L6.02326 4.94227C6.37485 4.59067 6.94495 4.59067 7.29654 4.94227L11.9302 9.57606L16.5641 4.94227C16.9156 4.59067 17.4858 4.59067 17.8373 4.94227L18.6845 5.78941C19.0361 6.14101 19.0361 6.71112 18.6845 7.06271L14.0507 11.6965L18.6842 16.3301C19.0358 16.6817 19.0358 17.2519 18.6842 17.6034L17.8371 18.4506C17.4855 18.8022 16.9156 18.8022 16.5641 18.4506Z"
        fill="#FE5F5F"
      />
      <path
        clipRule="evenodd"
        d="M11.6964 0C5.2367 0 0 5.2367 0 11.6964C0 18.1561 5.2367 23.3928 11.6964 23.3928C18.1561 23.3928 23.3928 18.1561 23.3928 11.6964C23.3928 5.2367 18.1561 0 11.6964 0ZM11.6964 21.6132C6.21955 21.6132 1.77962 17.1733 1.77962 11.6964C1.77962 6.21955 6.21955 1.77962 11.6964 1.77962C17.1733 1.77962 21.6132 6.21955 21.6132 11.6964C21.6132 17.1733 17.1733 21.6132 11.6964 21.6132Z"
        fill="#FE5F5F"
        fillRule="evenodd"
      />
    </svg>
  );
};
